import ActionFooter from '@components/components/HeatInstallationForm/components/ActionFooter';
import styles from '@components/components/HeatInstallationForm/components/Contact/Contact.module.scss';
import React from 'react';
import {
  Card,
  CardBody,
  Container,
  Content,
  Heading,
  InputField,
  Radio,
} from '@wienenergiegithub/ui-next';
import { FormGroupLabel, FormRadio, FormRadioGroup } from '@ariakit/react';

const Contact = ({
  store,
  prev,
  step,
  isGeneralRecommender,
  handleGeneralNextStep,
  isFinalStep,
}) => (
  <Container size="lg">
    <Heading size="h2">
      {isGeneralRecommender ? 'Ihre Kontaktdaten (4/4)' : 'Ihre Kontaktdaten:'}
    </Heading>
    <Content notResponsive size="lg">
      Füllen Sie bitte noch folgende persönliche Daten aus, damit wir sie
      kontaktieren können. Wir melden uns in Kürze bei Ihnen!
    </Content>
    <Card className={styles.container}>
      <CardBody className={styles.cardBody}>
        <Heading as="h3" size="h5">
          Ihre Adresse
        </Heading>

        <div className={styles.fieldRow}>
          <InputField
            className={styles.field}
            label="Straße"
            name="strasse"
            required
            store={store}
          />
          <InputField
            className={styles.field}
            label="Hausnummer"
            name="gebadr1"
            required
            store={store}
          />
          <InputField
            className={styles.field}
            label="Adresszusatz (optional)"
            name="tuerNr"
            store={store}
          />
        </div>
        <div className={styles.fieldRow}>
          <InputField
            className={styles.field}
            label="PLZ"
            name="plz"
            required
            store={store}
          />
          <InputField
            className={styles.fieldLarge}
            label="Ort"
            name="ort"
            required
            store={store}
          />
        </div>
      </CardBody>
    </Card>
    <br />
    <Card className={styles.container}>
      <CardBody className={styles.cardBody}>
        <Heading as="h3" size="h5">
          Ihre Daten
        </Heading>
        <FormRadioGroup name="anrede" store={store}>
          <FormGroupLabel
            className={styles.radioLabel}
            name="anrede"
            store={store}
          >
            Anrede
          </FormGroupLabel>
          <div className={styles.radios}>
            <FormRadio
              label="Frau"
              name="anrede"
              render={<Radio label="Frau" />}
              required
              store={store}
              value="Frau"
              variant="horizontal"
            />
            <FormRadio
              label="Herr"
              name="anrede"
              render={<Radio label="Herr" />}
              required
              store={store}
              value="Herr"
              variant="horizontal"
            />
            <FormRadio
              label="Divers"
              name="anrede"
              render={<Radio label="Divers" />}
              required
              store={store}
              value="divers"
              variant="horizontal"
            />
          </div>
        </FormRadioGroup>
        <div className={styles.fieldRow}>
          <InputField
            className={styles.field}
            label="Vorname"
            name="vorname"
            required
            store={store}
          />
          <InputField
            className={styles.field}
            label="Nachname"
            name="nachname"
            required
            store={store}
          />
        </div>
        <div className={styles.fieldRow}>
          <InputField
            className={styles.field}
            label="E-Mail"
            name="email"
            required
            store={store}
          />
          <InputField
            className={styles.field}
            label="Telefon (optional)"
            name="telefonnummer"
            store={store}
          />
        </div>

        <Content className={styles.dataProtectionLegal}>
          Durch das Anklicken des „ABSENDEN“ Buttons stimme ich zu, dass meine
          bekanntgegebenen personenbezogenen Daten (Name, Anrede, Anschrift,
          Telefonnummer, E-Mail-Adresse und Anlagedaten) von der Wien Energie
          GmbH zum Zweck der Kontaktaufnahme via E-Mail oder Telefon verarbeitet
          werden dürfen.
          <br />
          Sie können diese Einwilligung jederzeit durch ein E-Mail an{' '}
          <a
            href="mailto:datenschutz@wienenergie.at"
            rel="noreferrer"
            target="_blank"
          >
            datenschutz@wienenergie.at
          </a>{' '}
          widerrufen. Durch den Widerruf der Einwilligung wird die
          Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf
          erfolgten Verarbeitung nicht berührt. Bitte entnehmen Sie weitere
          Informationen zur Verarbeitung Ihrer Daten der{' '}
          <a
            href="https://wienenergie.at/datenschutz"
            rel="noreferrer"
            target="_blank"
          >
            Datenschutzerklärung
            {/* eslint-disable-next-line react/jsx-child-element-spacing */}
          </a>
          .
        </Content>
      </CardBody>
    </Card>
    <ActionFooter
      handleGeneralNextStep={handleGeneralNextStep}
      handleSkipStep={handleGeneralNextStep}
      isFinalStep={isFinalStep}
      isGeneralRecommender={isGeneralRecommender}
      nextText="Absenden"
      prev={prev}
      step={step}
      stepName="formular"
      store={store}
    />
  </Container>
);

export default Contact;
